import { useMutation } from 'query';
import { requestResetPassword } from '../../services';

type RequestResetPassword = { domain: string; email: string };

export const useRequestResetQuery = () =>
  useMutation<unknown, RequestResetPassword>({
    mutationFn: async ({ domain, email }: RequestResetPassword) =>
      requestResetPassword({ body: { domain, user: { email } } }),
  });
